import {createI18n} from 'vue-i18n'
import {getCookie} from "@/shared/lib/utils/cookie";

import jsonRu from '@/app/locales/ru.json';
import jsonKk from '@/app/locales/kk.json';
import jsonEn from '@/app/locales/en.json';

export const locales = ['ru', 'kk', 'en'] as const;
export type Locale = typeof locales[number];

let locale: string | null = getCookie('lang') ?? null;

const urlParams = new URLSearchParams(window.location.search);
const lang = urlParams.get("lang");
if (['kk', 'ru', 'kz'].includes(lang ?? '')) {
    locale = lang === 'kz' ? 'kk' : lang;
}

type Messages = Partial<typeof jsonRu | typeof jsonKk | typeof jsonEn>;

export default createI18n<[Messages, Messages, Messages], Locale>({
    inheritLocale: true,
    legacy: false,
    locale: (locale || import.meta.env.VITE_APP_I18N_LOCALE) as Locale,
    messages: {
        ru: jsonRu,
        kk: jsonKk,
        en: jsonEn,
    },
    pluralRules: {
        /**
         * @param choice {number} индекс выбора, переданный в $tc: `$tc('path.to.rule', choiceIndex)`
         * @param choicesLength {number} общее количество доступных вариантов
         * @returns финальный индекс для выбора соответственного варианта слова
         */
        'ru': function (choice, choicesLength) {
            // this === VueI18n экземпляра, так что свойство locale также существует здесь

            if (choice === 0) {
                return 0;
            }

            const teen = choice > 10 && choice < 20;
            const endsWithOne = choice % 10 === 1;

            if (choicesLength < 4) {
                return (!teen && endsWithOne) ? 1 : 2;
            }
            if (!teen && endsWithOne) {
                return 1;
            }
            if (!teen && choice % 10 >= 2 && choice % 10 <= 4) {
                return 2;
            }

            return (choicesLength < 4) ? 2 : 3;
        }
    }
})
